/*
  Brandkit Aromatique (pakket D, 14 okt 2026): toetsenbordtoegang voor Section Store-FAQ's
  (ss-faq-9, ss-faq-17) zonder hun code aan te passen (licentie). De tabs en vragen zijn daar
  <p>/<div> met alleen een klikhandler; dit script maakt ze focusbaar, geeft ze een knoprol,
  laat Enter/spatie de bestaande klik uitvoeren en houdt aria-expanded/aria-pressed bij.
  Controle-resultaten Q4-18. Ook: ai_gen d337feb (scrollende rij, Q4-20) en 928044a (labels stippen).
*/
(function () {
  if (window.__aaSsOverrides) return; // kan door meerdere blokken geladen worden
  window.__aaSsOverrides = true;
  function tokens(el) { return (el.getAttribute('class') || '').split(/\s+/); }
  function has(el, prefix, not) {
    return tokens(el).some(function (t) { return t.indexOf(prefix) === 0 && !(not && t.indexOf(not) === 0); });
  }
  function answerOf(trigger) {
    var item = trigger.parentElement;
    if (!item) return null;
    for (var i = 0; i < item.children.length; i++) {
      if (has(item.children[i], 'faq-answer-')) return item.children[i];
    }
    return null;
  }
  function syncExpanded(trigger) {
    var a = answerOf(trigger);
    if (a) trigger.setAttribute('aria-expanded', a.style.display !== 'none' ? 'true' : 'false');
  }
  function makeButton(el, kind) {
    if (el.dataset.aaKb) return;
    el.dataset.aaKb = '1';
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    if (kind === 'tab') el.setAttribute('aria-pressed', has(el, 'active') ? 'true' : 'false');
    if (kind === 'acc') syncExpanded(el);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); el.click(); }
    });
    el.addEventListener('click', function () {
      setTimeout(function () {
        if (kind === 'tab') {
          var row = el.parentElement;
          if (row) Array.prototype.forEach.call(row.children, function (t) {
            if (t.dataset.aaKb) t.setAttribute('aria-pressed', has(t, 'active') ? 'true' : 'false');
          });
        } else {
          syncExpanded(el);
          setTimeout(function () { syncExpanded(el); }, 700); // na de open/dicht-animatie van ss
        }
      }, 60);
    });
  }
  function initAiBlocks() {
    // d337feb "Use it for": op mobiel een horizontaal scrollende rij (Q4-20)
    Array.prototype.forEach.call(document.querySelectorAll('[class*="ai-use-it-for-grid-"]'), function (el) {
      if (!has(el, 'ai-use-it-for-grid-')) return;
      if (el.scrollWidth > el.clientWidth + 1) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'region');
        var h = el.parentElement && el.parentElement.querySelector('h2');
        el.setAttribute('aria-label', h ? h.textContent.trim() : 'Toepassingen');
      } else if (el.getAttribute('role') === 'region') {
        el.removeAttribute('tabindex');
      }
    });
    // 928044a trust-carrousel: Nederlandse labels en aria-current op de stippen
    Array.prototype.forEach.call(document.querySelectorAll('[class*="ai-trust-dots-"]'), function (wrap) {
      var dots = wrap.querySelectorAll('button');
      Array.prototype.forEach.call(dots, function (d, i) {
        d.setAttribute('aria-label', 'Ga naar dia ' + (i + 1) + ' van ' + dots.length);
        if (has(d, 'active')) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (!wrap.dataset.aaObs && window.MutationObserver) {
        wrap.dataset.aaObs = '1';
        new MutationObserver(function () { setTimeout(initAiBlocks, 0); })
          .observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
    });
  }
  function init() {
    initAiBlocks();
    Array.prototype.forEach.call(document.querySelectorAll('[class*="faq-"]'), function (el) {
      if (has(el, 'faq-toggles-')) {
        // scrollende tabrij (ss-faq-17): bereikbaar met het toetsenbord
        if (el.scrollWidth > el.clientWidth + 1) el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'group');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Onderwerpen');
        return;
      }
      if (has(el, 'faq-tab-toggle-')) { makeButton(el, 'acc'); return; }            // vraag in ss-faq-17
      if (has(el, 'faq-toggle-', 'faq-toggles-')) {
        // ss-faq-17: tab (<p> in de tabrij); ss-faq-9: vraagregel (<div> met antwoord ernaast)
        makeButton(el, answerOf(el) ? 'acc' : 'tab');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { setTimeout(init, 300); }); // stippen worden door het blok zelf later aangemaakt
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function () { setTimeout(init, 200); });
})();
